import React from 'react';

import { edit_user_email_settings_path } from '@routes';

import { ConfirmationTextType } from './interfaces';

export enum ConfirmationTypes {
  Confirmed = 'confirmed',
  Go = 'go',
  Offer = 'offer',
  PauseRateAnnual = 'pause_rate_annual',
  PauseRateMonthly = 'pause_rate_monthly',
  PauseSubscription = 'pause_subscription',
  Set = 'set',
  Stay = 'stay',
  Thanks = 'thanks',
}

export enum CancelReasons {
  Budget = 'budget',
  Duplicate = 'duplicate',
  Mismatch = 'mismatch',
  Other = 'other',
  Quality = 'quality',
  Technical = 'technical',
  Temporary = 'temporary',
  Time = 'time',
  Value = 'value',
}

export const CONFIRMATION_ANCILLARY_TEXT = {
  [CancelReasons.Budget]: 'We look forward to providing you with a better value for your money.',
  [CancelReasons.Duplicate]:
    'We look forward to ensuring your subscription experience is seamless.',
  [CancelReasons.Mismatch]:
    'We look forward to providing you with content that suits your interests better.',
  [CancelReasons.Other]: 'We look forward to providing you with enhanced experience.',
  [CancelReasons.Quality]: 'We look forward to providing you with refined content.',
  [CancelReasons.Technical]: 'We look forward to providing you with a seamless experience.',
  [CancelReasons.Temporary]:
    'We look forward to providing you continued access as your needs change.',
  [CancelReasons.Time]: 'We look forward to providing you with options to fit your schedule.',
  [CancelReasons.Value]: 'We look forward to providing you with improved benefits.',
};

export const CONFIRMATION_TEXT: ConfirmationTextType = {
  [ConfirmationTypes.Confirmed]: {
    headline: 'Subscription confirmed!',
    subheadline: 'We’re thrilled to have you back. Your new subscription details are below.',
    closing: 'Thank you for your continued support and loyalty.',
  },
  [ConfirmationTypes.Offer]: {
    headline: 'Offer applied!',
    subheadline:
      'We’re glad you decided to take advantage of our exclusive offer. Your subscription will continue without interruption. See your plan summary below.',
    closing: 'Thank you for your continued support and loyalty.',
  },
  [ConfirmationTypes.PauseRateAnnual]: {
    headline: 'Offer applied!',
    subheadline:
      'Thanks for accepting our offer. Your subscription will remain active, and you get to keep your current low rate for your next renewal. See your plan summary below.',
  },
  [ConfirmationTypes.PauseRateMonthly]: {
    headline: 'Offer applied!',
    subheadline:
      'Thanks for accepting our offer. Your 3 months of free access has been applied. Your subscription will remain active. See your plan summary below. Enjoy your break and we’ll see you soon!',
  },
  [ConfirmationTypes.PauseSubscription]: {
    headline: 'Pause confirmed!',
    subheadline:
      'Your subscription is now paused. Access will automatically resume after 60 days, or you can resume at any time by visiting your account page.',
  },
  [ConfirmationTypes.Set]: {
    headline: 'You’re all set!',
    subheadline:
      'We’re glad you decided to stay with us! Your subscription will continue without interruption. See your plan summary below.',
  },
  [ConfirmationTypes.Stay]: {
    headline: 'We’re thrilled you’ve decided to stay!',
    subheadline:
      'Your continued support and loyalty means a lot, and we’re committed to providing you with the best possible experience. Your subscription will continue without interruption and your payment on file will be charged for your next renewal. See your plan summary below.',
  },
  [ConfirmationTypes.Thanks]: {
    headline: 'Thanks for giving this a try!',
    subheadline:
      'You’ll receive a weekly digest in the following week. Your subscription will remain active and your payment on file will be charged for the next renewal. See your plan summary below.',
    closing: (
      <a
        className="underline hover:text-primary-magenta dark:hover:text-primary-pink"
        href={edit_user_email_settings_path()}
      >
        Manage your email preferences
      </a>
    ),
  },
};

export const LEARN_HOW = 'Learn how';
export const RESUBSCRIBE = 'resubscribe';
export const RESUBSCRIBE_HOW_TO_LINK =
  'https://theinformation.zendesk.com/hc/en-us/articles/218865617-I-previously-subscribed-and-want-to-sign-back-up-How-do-I-re-subscribe';
